var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconKomisi = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M8 8.223v.8c.203-.047.364-.16.364-.376 0-.197-.15-.323-.364-.424zM7.283 6.74c0 .174.155.282.382.377v-.71c-.268.053-.382.19-.382.334z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M8 0C3.578 0 0 3.578 0 8c0 4.422 3.578 8 8 8 4.422 0 8-3.578 8-8 0-4.422-3.578-8-8-8zm0 13.781c-3.188 0-5.781-2.593-5.781-5.781 0-3.188 2.593-5.781 5.781-5.781 3.188 0 5.781 2.593 5.781 5.781 0 3.188-2.593 5.781-5.781 5.781z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M8 3.156C5.33 3.156 3.156 5.33 3.156 8c0 2.67 2.173 4.844 4.844 4.844 2.67 0 4.844-2.173 4.844-4.844 0-2.67-2.173-4.844-4.844-4.844zm.06 6.698v.173c0 .084-.114.162-.227.162-.131 0-.227-.078-.227-.162v-.149c-.716-.024-1.301-.394-1.301-.777 0-.203.179-.502.406-.502.25 0 .453.353.895.43v-.968c-.55-.209-1.194-.466-1.194-1.23 0-.76.561-1.124 1.194-1.214V5.45c0-.084.096-.162.227-.162.113 0 .227.078.227.162v.15c.37.011 1.068.107 1.068.519 0 .161-.107.49-.37.49-.197 0-.31-.191-.698-.221v.873c.543.203 1.176.484 1.176 1.29 0 .741-.478 1.19-1.176 1.303z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconKomisi, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_komisi.c6d7c24a.svg";
export { ForwardRef as ReactComponent };